import PlatformIntegrationAPI from '../../api/PlatformIntegrationAPI';
import {
  googleTagManager,
  triggerFacebookPixelIntegrationEvent,
} from '../../shared/platformIntegrationUtils';
import {
  IIntegration,
  PlatformIntegrationEnum,
  PlatformIntegrationEventEnum,
} from '../../types/integrationType';
import { setPlatformIntegration } from '../platformIntegration';
import { AppDispatch, AppThunk, RootState } from '../store';

export const fetchPlatformIntegration =
  (host: string) => async (dispatch: AppDispatch) => {
    try {
      const query = new URLSearchParams({
        host,
      });
      const response = await PlatformIntegrationAPI.getEnabledEvents(
        query.toString(),
      );
      if (response.code === 200 && response.result) {
        let facebook: IIntegration = {
          platform: PlatformIntegrationEnum.FACEBOOK_CONVERSATION,
          integrationId: '',
          events: [],
        };
        let google: IIntegration = {
          platform: PlatformIntegrationEnum.GOOGLE_TAG_MANAGER,
          integrationId: '',
          events: [],
        };
        response.result.forEach((integration) => {
          if (
            integration.platform ===
            PlatformIntegrationEnum.FACEBOOK_CONVERSATION
          ) {
            facebook = integration;
          }

          if (
            integration.platform === PlatformIntegrationEnum.GOOGLE_TAG_MANAGER
          ) {
            google = integration;
          }
        });
        dispatch(
          setPlatformIntegration({
            [PlatformIntegrationEnum.FACEBOOK_CONVERSATION]: facebook,
            [PlatformIntegrationEnum.GOOGLE_TAG_MANAGER]: google,
          }),
        );
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const triggerEventAction =
  (
    eventName: PlatformIntegrationEventEnum,
    queryObject: Record<string, unknown> = {},
  ): AppThunk<Promise<void>> =>
  async (_: unknown, getState: () => RootState) => {
    const { platformIntegration, app } = getState();
    const { hostMetadata } = app;
    const {
      [PlatformIntegrationEnum.GOOGLE_TAG_MANAGER]: google,
      [PlatformIntegrationEnum.FACEBOOK_CONVERSATION]: facebook,
    } = platformIntegration;
    if (google.events.includes(eventName)) {
      googleTagManager(google.integrationId, eventName, queryObject);
    }
    if (facebook.events.includes(eventName)) {
      triggerFacebookPixelIntegrationEvent(
        hostMetadata?.creator?._id,
        eventName,
        queryObject,
      );
    }
  };
